import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauth-main-layout',
  templateUrl: './unauth-main-layout.component.html',
  styleUrls: ['./unauth-main-layout.component.scss'],
})
export class UnauthMainLayoutComponent implements OnInit {
  @Input() desktopVideoUrl: string;
  @Input() tabletVideoUrl: string;
  @Input() mobileVideoUrl: string;
  @Input() showStamp = true;
  extendPage = false;

  constructor(private router: Router) {}

  ngOnInit() {
    this.extendPage = this.router.url.includes('registration');
  }
}
